
































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
import moment from "moment";
import vSelect from "vue-select";
import i18n from "@/i18n";
// components
import FolderTree from "@/components/common/folders/FolderTree.vue";
import PlayerInfoModal from "@/components/players/modals/PlayerInfoModal.vue";
import PlayerLogsModal from "@/components/players/modals/PlayerLogsModal.vue";
import PlayerActivationModal from "@/components/players/modals/PlayerActivationModal.vue";
import PlayerDeleteModal from "@/components/players/modals/PlayerDeleteModal.vue";
// types
import { Player, PlayerActionType, PlayerMultipleActionDto } from "@/services/players/types";
import { Folder, FolderEntites } from "@/services/folders/types";
import { Option } from "@/services/common/types";
import { playerFields } from "@/components/players/fields/playerFields";
// service methods
import { getPlayers, setMultipleAction, getPreviewRenderUrl } from "@/services/players/playerService";

@Component({
    components: {
        PlayerDeleteModal,
        PlayerActivationModal,
        PlayerLogsModal,
        FolderTree,
        vSelect,
        PlayerInfoModal
    }
})
export default class Players extends Vue {
    // local state
    players = [] as Player[];
    fields = playerFields;
    isBusy = false;

    // folders
    folderEntity = FolderEntites.Players;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;

    // filter
    selectedSolution = null as Option | any;

    // filter options
    searchQuery = "";
    playerStatus = [{ id: "true", text: i18n.t("player.filterSelectActive") }, { id: "false", text: i18n.t("player.filterSelectInactive") }];
    currentStatus = null as Option | any;

    // lifecycle hooks
    public created(): void {
        this.fetchData();
        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // Watchers
    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        this.showFolderTree = !value;
    }

    // computed
    get filteredData(): Array<Player> {
        let returnPlayers = [] as Player[];
        if (this.filterActive) {
            returnPlayers = this.players.filter(
                x =>
                    this.searchQuery.length === 0 ||
                    x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    x.playerId.toString().includes(this.searchQuery)
            );
        } else {
            returnPlayers = this.players.filter(x =>
                this.selectedFolderNode.id
                    ? x.folderId === this.selectedFolderNode.id
                    : true
            );
        }

        if (this.currentStatus !== null) return returnPlayers.filter(x => x.status.toString() === this.currentStatus.id);
        return returnPlayers;
    }

    get filterActive(): boolean {
        return (
            (this.selectedSolution &&
                Object.keys(this.selectedSolution.id).length > 0) ||
            this.searchQuery !== ""
        );
    }

    // methods
    fetchData() {
        this.isBusy = true;
        getPlayers().then(response => {
            this.players = response;
            this.isBusy = false;
        });
    }

    setPlayerFolderId(data: { entityId: string, folderId: string }) {
        this.players.forEach(player => {
            if (player.id === data.entityId) { player.folderId = data.folderId; }
        });
    }

    selectFolder(folder: Folder) {
        this.selectedFolderNode = folder;
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
        }
    }

    info(playerId: string) {
        (this.$refs.playerInfoModal as any).open(playerId);
    }

    logs(playerId: string) {
        (this.$refs.playerLogsModal as any).open(playerId);
    }

    addPlayer() {
        (this.$refs.playerActivationModal as any).resetState();
        this.$bvModal.show("modal-playerActivation");
    }

    clearFilter() {
        this.currentStatus = null as Option | any;
    }

    formatDate(date: Date) {
        return moment.utc(date).local().format("LLL");
    }

    deletePlayer(playerId: string, playerName: string) {
        (this.$refs.playerDeleteModal as any)
            .open(playerId, playerName);
    }

    massReboot() {
        setMultipleAction({
            actionType: PlayerActionType.reboot,
            massAction: true
        } as PlayerMultipleActionDto);
    }

    massReload() {
        setMultipleAction({
            actionType: PlayerActionType.reRender,
            massAction: true
        } as PlayerMultipleActionDto);
    }

    massScreenshot() {
        setMultipleAction({
            actionType: PlayerActionType.screenshot,
            massAction: true
        } as PlayerMultipleActionDto)
            .then(() => {
                this.$router.push("/players/screenshots");
            });
    }

    navigateToRender(playerId: string) {
        getPreviewRenderUrl(playerId).then(response => {
            window.open(response, "_blank");
        });
    }

    getStatusText(player: Player) {
        if (player.status) return i18n.t("common.online");
        let response = i18n.t("common.offline");
        if (player.lastActiveDate) response += ` ${i18n.t("solution.since")} ${moment.utc(player.lastActiveDate).local().format("dddd")} <br> ${i18n.d(new Date(player.lastActiveDate), "short")} ${moment.utc(player.lastActiveDate).local().format("HH:mm")}`;
        return response;
    }

    // drag events
    drag(event: any) {
        event.dataTransfer.setDragImage(
            this.$refs[
                "element_" + event.target.getAttribute("entityId")
            ] as any,
            -10,
            0
        );
        event.dataTransfer.setData("type", event.target.getAttribute("type"));
        event.dataTransfer.setData(
            "folderEntity",
            event.target.getAttribute("folderEntity")
        );
        event.dataTransfer.setData(
            "entityId",
            event.target.getAttribute("entityId")
        );
    }
}
